import { get } from './axios.js'

let api = '/api'

export const getSearchColumn = query => get(api + '/searchArticleColumnList?' + (query || ''))
export const getSearchNews = query => get(api + '/searchArticleList?' + (query || ''))
